import { render, staticRenderFns } from "./ListCardBadgeCollection.vue?vue&type=template&id=99089a36&"
import script from "./ListCardBadgeCollection.vue?vue&type=script&lang=js&"
export * from "./ListCardBadgeCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports